<div *ngIf="!showLoading" id="customer-complete-profile">

  <form class="form" [formGroup]="completeProfileFormGroup">
    <div class="row">
      <div class="col-md-12">
        <div class="complete-profile">
          <h2><strong>{{cfetLabels.cfet_complete_profile.heading}}</strong></h2>
        </div>
      </div>
    </div>

    <div class="row form-row" id="user-id">
      <div class="col-md-12">
        <label for="userid">{{cfetLabels.cfet_complete_profile.user_id}}</label>
        <div class="inputbox">
          <input id="userId" class="userId" name="userId" tabindex="0" formControlName="emailAddress" maxlength="256"
            type="text" autocomplete="off">
          <div id="email_info"><span>{{cfetLabels.cfet_complete_profile.email_info}}</span></div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="password" [class.error]="(newPassword?.errors &&
     !newPassword.errors.required && errorFlagPArray[0] || cfetService.pwdObj.isErrorCodeArray[0] || isWeakPassword)"
      [ngClass]="isFocusOn ? 'addExtraPadding' : ''">
      <div class="col-md-12">
        <label for="input_create_pass">{{cfetLabels.cfet_complete_profile.create_password}}</label>
        <div class="inputbox">
          <div class="field-group new-password-input">
            <abs-tooltip id="tooltip" class="field-group abs-tooltip-onfocus">
              <app-password-validation-tooltip id="reset-pwd-tooltip" class="abs-tooltip-onfocus reset-pwd-tooltip"
                [consecutiveFlagFlow]=false [index]=0 (emitedPassword)="emitedPasswordMethodReset($event)"
                (isFocusOn)="isPasswordTooltipExpanded($event)" (change)="changeConfirmPassword($event)">
              </app-password-validation-tooltip>
            </abs-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="confirm-password" [class.error]="isInvalidPassword || isWeakPassword">
      <div class="col-md-12">
        <label for="input_confirm_pass">{{cfetLabels.cfet_complete_profile.confirm_password}}</label>
        <div class="field-group noPadding inputbox">
          <input id="input_confirm_password" name="confirm_password" formControlName="confirmPassword" autocomplete="off"
            tabindex="0" type="password" minlength="8" maxlength="24" restrict-input="restrictPasswordNew"
            [type]="showPassword ? 'text' : 'password'" (change)="changeConfirmPassword($event)" (click)="pwdKeyup($event)"
            (keyup)="pwdKeyup($event)" (blur)="pwdBlur()"
            [ngClass]="(isFocus || confirmPassword.value) ? 'focusOn' : '' " aria-label="Confirm password">
          <span *ngIf="confirmPassword.value" class="password_close_icon padRight35" id="cross-icon-pwd0">
            <img *ngIf="confirmPassword.value" id="close" (click)="resetInputField($event)" (keyup)="resetInputField($event)"
              src="assets/images/C100_Close_16.png" alt="Close" role="img" tabindex="0" aria-label="icon-close">
            <img *ngIf="confirmPassword.value" id="line" src="assets/images/Line.png" alt="Line" role="img"
              aria-label="icon-line">
          </span>
          <span *ngIf="confirmPassword.value || isFocus" class="password_close_icon padRight35" id="cross-icon-pwd0">
            <img *ngIf="showPassword" id="blue_eye" src="assets/images/Eye_Icon_blue_hide.png" alt="BlueEye" role="img"
              tabindex="0" aria-label="icon-eye-hide" (click)="showHidePassword($event)"
              (keyup)="showHidePassword($event)"
              [ngClass]="(isFocus && !confirmPassword.value) ? 'focusOnBlueEye' : ''">
            <img *ngIf="!showPassword" id="blue_eye" src="assets/images/Eye_Icon_blue.png" alt="BlueEye" role="img"
              tabindex="0" aria-label="icon-eye-show" (click)="showHidePassword($event)"
              (keyup)="showHidePassword($event)"
              [ngClass]="(isFocus && !confirmPassword.value) ? 'focusOnBlueEye' : ''">
          </span>
          <span *ngIf="!confirmPassword.value && !isFocus"
            [ngClass]="{'pwd_icon_hide': showPassword, 'pwd_icon_show' : !showPassword}" id="pwd-icon0"
            (click)="showHidePassword($event)" (keyup)="showHidePassword($event)" class="padLeft15">
            <img *ngIf="showPassword" id="black_eye" src="assets/images/Eye_Icon_black_hide.png" alt="Eye" role="img"
              tabindex="0" aria-label="icon-eye-hide">
            <img *ngIf="!showPassword" id="black_eye" src="assets/images/Eye_Icon_black.png" alt="Eye" role="img"
              tabindex="0" aria-label="icon-eye-show">
          </span>
        </div>
        <div id="account-confirm-error" *ngIf="isInvalidPassword" role="alert" [attr.aria-atomic]="true"
          [ngClass]="{'error-msg' : isInvalidPassword}">
          <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
          <span id="error_confirm_password_mismatch">{{cfetMessages.password_mismatch}}</span>
        </div>
        <div id="account-confirm-error" *ngIf="isWeakPassword" role="alert" [attr.aria-atomic]="true"
          [ngClass]="{'error-msg' : isWeakPassword}">
          <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
          <span id="error_confirm_password_weak">{{cfetMessages.strong_password}}</span>
        </div>
      </div>
    </div>

    <div class="row form-row" id="security-question">
      <div class="col-md-12">
        <div class="field-group">
          <label for="select_security_question">{{cfetLabels.cfet_complete_profile.security_question}}
            <abs-tooltip class="abs-tooltip">
              <a #userActivationQTooltip class="icon-tooltip tooltip-element" tabindex="0" role="button"
                data-placement="top" (click)="tooltipSonarFix('UserActivationQTooltip')"
                (keydown)="tooltipSonarFix('UserActivationQTooltip')" aria-label="Help" aria-expanded="false"
                aria-describedby="security_question_tooltip">
                <span class="arrow"></span>
              </a>
              <span id="tooltip" class="abs-tooltip-wrapper">
                <span class="abs-tooltip-size-control">
                  <span id="security_question_tooltip" role="tooltip" [attr.aria-live]="'polite'"
                    [attr.aria-hidden]="'true'" class="abs-helpertext" tabindex="-1">
                    <span class="abs-popover-content">
                      <span>{{cfetLabels.cfet_complete_profile.security_questions_def}}</span>
                    </span>
                  </span>
                </span>
              </span>
            </abs-tooltip>
          </label>
        </div>
        <div class="field-group mt-3">
          <div [ngClass]="questionExpanded ? 'dropdown-opened' : ''">
            <abs-dropdown [drId]="'select_security_question'" [drName]="'securityQuestion'"
              [(dropdownValue)]="SecurityQuestionvalue" formControlName="securityQuestion"
              [optionRepeat]="securityQuestionsList" (dropdownValueChange)="selectQuestions($event)"
              (click)="onClickSecurityQuestion($event)" ngDefaultControl>
            </abs-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="security-ans"
      [class.error]="securityAnswer.errors && securityAnswer.errors.minlength">
      <div class="col-md-12">
        <label for="input_security_answer">{{cfetLabels.cfet_complete_profile.security_answer}}</label>
        <div class="inputbox">
          <input class="security_answer" id="security_answer" name="security_answer" formControlName="securityAnswer" autocomplete="off"
            tabindex="0" maxlength="20" type="text" restrict-input="securityAnswer" aria-label="Answer">
          <div *ngIf="securityAnswer.errors && securityAnswer.errors.minlength" id="security-answer-err"
            [attr.aria-atomic]="true" role="alert"
            [ngClass]="{'error-msg' : securityAnswer.errors && securityAnswer.errors.minlength}">
            <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
            <span id="error_security_answer">{{cfetMessages.security_minlenth_three}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="time-zone">
      <div class="col-md-12">
        <label for="time_zone">
          {{cfetLabels.cfet_complete_profile.time_zone}}</label>
        <div class="field-group">
          <div [ngClass]="timezoneExpanded ? 'dropdown-opened' : ''">
            <abs-dropdown [drId]="'time_zone'" [drName]="'timeZone'" [(dropdownValue)]="timeZoneValue"
              formControlName="timeZone" [optionRepeat]="timeZoneList" (dropdownValueChange)="selectTimezone($event)"
              (click)="onClickTimeZone($event)" ngDefaultControl>
            </abs-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="confirm-checkbox">
      <div class="col-md-12">
        <label for="affirm-checkbox" class="checkbox">
          <input id="affirm-checkbox" tabindex="0" type="checkbox" (click)="confirmCheckbox($event)"
            (keyup)="confirmCheckbox($event)" [checked]="isChecked" unchecked required />
          <em class="skin" tabindex="-1"></em>
          <span>
            <label for="checkbox-content" class="checkboxContent">{{cfetLabels.cfet_complete_profile.affirm}}
              <a id="link_terms_condition" class="link_terms_condition" (click)="openTerms($event)"
                (keyup)="openTerms($event)" role="link" tabindex="0">
                {{cfetLabels.cfet_complete_profile.terms}}</a>
            </label>
          </span>
        </label>
      </div>
    </div>

    <div class="row" id="complete-profile-footer-column1">
      <div class="col-md-12">
        <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)"
          class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledSubmitButton()">
          {{cfetButtonLabels.button_labels.done}}</button>
      </div>
    </div>
    <div class="row" id="complete-profile-footer-column2">
      <div class="col-md-12">
        <a data-dismiss="modal" (click)="cancel($event)" (keyup)="cancel($event)" tabindex="0" type="link"
          id="cancel_link" class="btn btn-secondary btn-clear cancel_link">
          {{cfetButtonLabels.button_labels.cancel}}</a>
      </div>
    </div>

  </form>
  <div [ngClass]="showInactivityModal ? 'open-inactivity-modal' : ''">
    <app-customer-inactivity-modal [openModal]="openInactivityModal"
      (closeInactivityModal)="closeInactivityModal($event)">
    </app-customer-inactivity-modal>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>

<div [ngClass]="showCancelModal ? 'open-cancel-modal' : 'hide-cancel-modal'">
  <app-customer-cancel-modal [openModal]="openCancelModal" (closeCancelModal)="closeCancelModal($event)">
  </app-customer-cancel-modal>
</div>